<label [class]="{'label': true, 'p-disabled': !enabled}">{{label}}<span class="p-required-fiel-form"
        *ngIf="required==='true' || required===true">*</span></label>